var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgConstruction = function SvgConstruction(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 20,
    height: 8,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 14v7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14v7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3v3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3v3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14 2.3 6.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m14 6 7.7 7.7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m8 6 8 8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgConstruction);
export default ForwardRef;